import React, {Fragment} from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { compose} from "redux";
import { connect } from "react-redux";
import numberFormatter from 'utils/numberFormatter';

const Wrapper = styled.div`
  width:350px;
`
const BlueResult = styled.div`
  align-items:center;
  background:#DADCE0;
  color:#000;
  display:flex;
  flex-flow: column nowrap;    
  padding:32px;
  margin-bottom:16px;
`

const CenterAlignedValue = styled.div`
  && {
  font-size:24px !important;
  text-align:center;
  }
`
const WhiteBackground = styled.div`    
  text-align:center;  
  background:#fff;  
  width:100%;
  padding:12px 0;
  margin-bottom:32px;
`
const BigText = styled.div`
  && {
    font-family: Work Sans;
    font-size: 36px !important;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;    
    margin:8px 0;  
  }
`
const Label = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;   
  text-transform:uppercase;
  font-size:13px !important;
`
const CenterAlignedLabel = styled(Label)`&& {
    text-align:center;
  }
`
const VerticalSpace = styled.div`
  margin:8px 0;  
`

const Disclosure = styled.div`&& {
    font-family: Work Sans;    
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0em;  
    font-size:13px !important;
  }
`
const Headline = ({value, label}) => {  
  return (
    <WhiteBackground>
      <BigText>{value}</BigText>
      <CenterAlignedLabel>{label}</CenterAlignedLabel> 
    </WhiteBackground>
  )
}
const PrimaryData = ({value, label}) => {
  return (
    <VerticalSpace>
      <CenterAlignedValue>{value}</CenterAlignedValue>
      <CenterAlignedLabel>{label}</CenterAlignedLabel>
    </VerticalSpace>
  )
}
class AnalysisResult extends React.Component {
  state = {
    
  }

  render() {      
    let swap = this.props.swap;    
    if(!swap.midRate)
      return null;
    return (
      <Wrapper>
        <BlueResult>
          {swap.allInRate !== null && <Headline value={numberFormatter.formatRate(swap.allInRate,3)} label="all-in rate"></Headline>}
          {swap.creditCharge !== null && <Headline value={numberFormatter.formatDecimal(swap.creditCharge,1)} label="credit charge (bps)"></Headline>}
          <PrimaryData value={numberFormatter.formatMoney(swap.swapRevenue)} label="swap revenue"/>
          <PrimaryData value={numberFormatter.formatMoney(swap.pv01, 2)} label="PV01"/>
          <PrimaryData value={numberFormatter.formatRate(swap.midRate,3)} label="mid rate"/>
        </BlueResult>
        <Disclosure>Calculations are for informational purposes and subject to change with market conditions.</Disclosure>
      </Wrapper>
    )};

}
function mapStateToProps({calculators}) {  
  return {
    swap: calculators.bankSwap.swap,     
  }
}
export default compose(  
  connect(
    mapStateToProps,
    {
      
    }
  )
)(AnalysisResult);